import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";

import SectionHeader from "../components/SectionHeader";
import { getintouchCompData } from "../data/components-getintouch.data";
import { trackEvent } from "../plausible";
import { Helmet } from "react-helmet";
import { VectorBackground } from "../components/VectorBackground";

const GetInTouch = ({
    hideHeader,
    pageTitle,
    transparentBackground,
    borderedForm,
}) => {
    const compData = getintouchCompData();

    const { label, header } =
        compData.wp.mdaThemeOptions.themeSettings.getintouch;

    useEffect(() => {
        const handleSuccess = () => {
            trackEvent("Contact Form: Submitted", {
                props: {
                    "contact-form-page-title": pageTitle,
                },
            });
        };

        window.addEventListener(
            "hs-form-event:on-submission:success",
            handleSuccess
        );
        return () => {
            window.removeEventListener(
                "hs-form-event:on-submission:success",
                handleSuccess
            );
        };
    }, [pageTitle]);

    return (
        <Container>
            <VectorBackground gradient strokeOpacity={0.2} />
            <Row className="get-in-touch" id="get-in-touch">
                <Col xs="24" style={{ position: "relative" }}>
                    <Row
                        className={`get-in-touch__content ${
                            transparentBackground
                                ? "get-in-touch__content--transparent"
                                : ""
                        }`}
                    >
                        {!hideHeader && (
                            <Col
                                xl={{ span: 14, offset: 5 }}
                                xs={{ span: 22, offset: 1 }}
                            >
                                <div className="get-in-touch__headline">
                                    <SectionHeader
                                        labelBottom={label}
                                        header={header}
                                        variant="light"
                                    />
                                </div>
                            </Col>
                        )}

                        <Col
                            xl={{
                                span: 14,
                                offset: hideHeader ? 0 : 5,
                            }}
                            xs={{ span: 22, offset: hideHeader ? 0 : 1 }}
                        >
                            <Helmet>
                                <script
                                    src="https://js-eu1.hsforms.net/forms/embed/developer/25477516.js"
                                    defer
                                ></script>
                            </Helmet>
                            <div
                                className={`hs-form-html get-in-touch__form ${
                                    borderedForm
                                        ? "get-in-touch__form--bordered"
                                        : ""
                                }`}
                                data-region="eu1"
                                data-form-id="b539121c-22cc-4775-829b-47a632b2fb8a"
                                data-portal-id="25477516"
                            ></div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default GetInTouch;
